import { RotateCw } from 'lucide-preact'
import { text } from '#contract'
import { useView } from '../app/use-view.ts'
import { Button } from '../components/button.tsx'
import { ScreenPanel } from '../components/screen-panel.tsx'
import { useT } from '../i18n/index.ts'
import { Text } from '../i18n/text.tsx'
import styles from './error-screen.module.css'

/** A fatal boot or load error. Reloading the page is the only way out. */
export function ErrorScreen() {
  const t = useT()
  const error = useView((view) => view.error)

  return (
    <ScreenPanel
      title={<Text value={error?.title ?? text('error.bootFailed')} />}
      footer={
        <Button
          icon={RotateCw}
          autoFocus
          onClick={() => {
            location.reload()
          }}
        >
          {t(text('error.reload'))}
        </Button>
      }
    >
      <p class={styles.hint}>{t(text('error.hint'))}</p>
      {error && <pre class={styles.detail}>{error.detail}</pre>}
    </ScreenPanel>
  )
}
